import {NgModule} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {MatTooltipModule} from '@angular/material/tooltip';
import {InfoPopupComponent} from './info-popup.component';
import {CommonModule} from '@angular/common';

const COMPONENTS = [
    InfoPopupComponent,
];

@NgModule({
    declarations: COMPONENTS,
    imports: [
        MatIconModule,
        MatButtonModule,
        MatTooltipModule,
        CommonModule,
    ],
    exports: COMPONENTS
})
export class CbInfoPopupModule {
}
